import { createContext, useCallback, useContext, useState } from "react";

export const NotificationContext = createContext();
NotificationContext.displayName = "Notification";
export const useNotification = () => useContext(NotificationContext);

const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);
    const [showNotificationPanel, setShowNotificationPanel] = useState(false);

    /**
     * type: info (default), success, warning, error, request
     */
    const addNotification = useCallback(({ type = "info", message, actionTitle, onAction }) => {
        const notification = {
            id: `${Date.now().toString()}_${type}_${Math.random().toString(36).slice(2, 8)}`,
            time: Date.now(),
            type,
            message,
            actionTitle,
            onAction,
            read: false,
        };

        setNotifications((prev) => [...prev.slice(-30), notification]);
    }, []);

    const clearNotifications = useCallback(() => {
        setNotifications([]);
    }, []);

    const markAllNotificationsRead = useCallback(() => {
        setNotifications((prev) =>
            prev.some((n) => !n.read) ? prev.map((n) => (n.read ? n : { ...n, read: true })) : prev
        );
    }, []);

    const hasUnreadNotifications = useCallback(
        () => notifications.some((notification) => !notification.read),
        [notifications]
    );

    return (
        <NotificationContext.Provider
            value={{
                notifications,
                showNotificationPanel,
                setShowNotificationPanel,
                addNotification,
                clearNotifications,
                markAllNotificationsRead,
                hasUnreadNotifications,
            }}
        >
            {children}
        </NotificationContext.Provider>
    );
};

export default NotificationProvider;
